/* NetworkDiscoveryDetailsViewRenderer.js */

"use strict";
/* global Slick */
const _ = require("lodash");
const Forms = require("@gluenetworks/forms");
const FormsComponent = Forms.ui.component;
const BaseRefResolver = Forms.resolvers.ref.base;
require("moment-duration-format");

const formatters = require("./cellFormaters");

const uiCore = require("@gluenetworks/steve_ui_core");
const {InputText, InputNumber} = uiCore.Control.Textfield;
const {ComboBox, InputRadio} = uiCore.Control.OptionSelection.Single;
const {Button} = uiCore.Control.Action;
const {InputCheckbox} = uiCore.Control.Boolean;
const StatusFlow = require("./StatusFlowComponent");

const childViewComponent = require("../../../../widgets/childview/ChildViewRenderer");
const manageDeviceComponent = require("./subviews/manage_device/ManageDeviceViewComponent");

const AddEditTargetsScreen = require("./veils/addrange/AddRangeComponent");

const AddEditCredentialsScreen = require("./veils/addeditcredential/AddEditCredentialComponent");

const createEditExclusion = require("./veils/createeditexclusion/CreateEditExclusionComponent");

class NetworkDiscoveryViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("network-discovery-details-view-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._nameField = {};
        this._descField = {};
        this._statusField = {};

        this._renderingForm = true;

        this._tableOptions = {
            editable: true,
            enableCellNavigation: true,
            enableAsyncPostRender: true,
            forceFitColumns: true,
            autoExpandColumns: true,
            autoHeight: false,
            autoEdit: true,
            rowHeight: 40,
        };

        this._refResolver = new BaseRefResolver(
            this._model._nibApiService,
            this._model._userSession,
            true
        );
        this._formsComponent = new FormsComponent(this._refResolver, undefined, false);

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Save",
            name: "SaveDiscovery",
            handler: (this._onSaveDiscovery = this._onSaveDiscovery.bind(this)),
        });
        this._model.gameEditor.disableViewAction("SaveDiscovery");
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Cancel",
            name: "CancelDiscovery",
            handler: (this._onCancelDiscovery = this._onCancelDiscovery.bind(this)),
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Schedule",
            name: "ScheduleDiscovery",
            handler: (this._onScheduleDiscovery = this._onScheduleDiscovery.bind(this)),
        });
        // this._model.gameEditor.disableViewAction("ScheduleDiscovery");
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Run Now",
            name: "RunDiscovery",
            handler: (this._onRunDiscovery = this._onRunDiscovery.bind(this)),
        });

        this._debouncedOnDiscoveryPropertiesChanged = _.debounce(
            this._onDiscoveryPropertiesChanged.bind(this),
            400,
            false
        );

        this._resizeTargetsWithDelay = _.debounce(this._resizeTargetsWithDelay.bind(this), 300);
        this._resizeCredentialsWithDelay = _.debounce(
            this._resizeCredentialsWithDelay.bind(this),
            300
        );
        this._resizeExclusionsWithDelay = _.debounce(
            this._resizeExclusionsWithDelay.bind(this),
            300
        );

        this._onWorkIdUpdated = this._onWorkIdUpdated.bind(this);

        // this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._nameField.on(
            "UserValue",
            (this._nameFieldChanged = this._nameFieldChanged.bind(this))
        );
        this._descField.on(
            "UserValue",
            (this._descFieldChanged = this._descFieldChanged.bind(this))
        );
        this._engineZone.on(
            "UserValue",
            (this._zoneFieldChanged = this._zoneFieldChanged.bind(this))
        );

        this._rangesConnectionType.on(
            "UserValue",
            (this._rangesConnectionTypeFieldChanged =
                this._rangesConnectionTypeFieldChanged.bind(this))
        );
        this._rangesPort.on(
            "UserValue",
            (this._rangesPortFieldChanged = this._rangesPortFieldChanged.bind(this))
        );

        this._searchType.on(
            "UserValue",
            (this._searchTypeFieldChanged = this._searchTypeFieldChanged.bind(this))
        );
        this._searchDepth.on(
            "UserValue",
            (this._searchDepthFieldChanged = this._searchDepthFieldChanged.bind(this))
        );
        this._useInitial.on(
            "UserValue",
            (this._useInitialFieldChanged = this._useInitialFieldChanged.bind(this))
        );
        this._useArp.on(
            "UserValue",
            (this._useArpFieldChanged = this._useArpFieldChanged.bind(this))
        );
        this._vrfName.on(
            "UserValue",
            (this._vrfNameFieldChanged = this._vrfNameFieldChanged.bind(this))
        );
        this._useCdp.on(
            "UserValue",
            (this._useCdpFieldChanged = this._useCdpFieldChanged.bind(this))
        );
        this._useLldp.on(
            "UserValue",
            (this._useLldpFieldChanged = this._useLldpFieldChanged.bind(this))
        );

        this._formsComponent.on(
            "PendingPatchesChanged",
            (this._onFormsPendingPatchesChanged = _.debounce(
                this._onFormsPendingPatchesChanged.bind(this),
                500,
                false
            ))
        );

        this._formsComponent.on(
            "PristineValueChanged",
            (this._onPristineValueChanged = _.debounce(
                this._onPristineValueChanged.bind(this),
                500,
                false
            ))
        );
        this._mode.on("UserValue", (this._modeChange = this._modeChange.bind(this)));
        this._selectSeededDevice.on(
            "UserClick",
            (this._selectSeededDeviceClick = this._selectSeededDeviceClick.bind(this))
        );
        this._addNewRangeButton.on(
            "UserClick",
            (this._addNewRangeClick = this._addNewRangeClick.bind(this))
        );
        this._model.on(
            "UpdateTargetsGrid",
            (this._resetTargetsGrid = this._resetTargetsGrid.bind(this))
        );
        document.addEventListener("click", (this._clickHandler = this._clickHandler.bind(this)));
        this._addNewCredButton.on(
            "UserClick",
            (this._addNewCredentialClick = this._addNewCredentialClick.bind(this))
        );
        this._model.on(
            "UpdateCredentialsGrid",
            (this._resetCredentialsGrid = this._resetCredentialsGrid.bind(this))
        );
        this._addNewExclusionButton.on(
            "UserClick",
            (this._addNewExclusionClick = this._addNewExclusionClick.bind(this))
        );
        this._model.on(
            "UpdateExclusionsGrid",
            (this._resetExclusionsGrid = this._resetExclusionsGrid.bind(this))
        );

        window.addEventListener("resize", (this._fitTableSize = this._fitTableSize.bind(this)));

        this._model.on("ResetView", (this._resetView = this._resetView.bind(this)));
        this._model.on("Status", (this.updateStatus = this.updateStatus.bind(this)));
        // this._model.on("Dirty", (this._onDirtyState = this._onDirtyState.bind(this)));
        this._model.on(
            "NetworkDiscoveryPropertiesChanged",
            this._debouncedOnDiscoveryPropertiesChanged
        );
        this._model.on("DiscoveryWorkIdUpdated", this._onWorkIdUpdated);
    }

    _unregisterListeners() {
        this._nameField.removeListener("UserValue", this._nameFieldChanged);
        this._descField.removeListener("UserValue", this._descFieldChanged);
        this._engineZone.removeListener("UserValue", this._zoneFieldChanged);

        this._searchType.removeListener("UserValue", this._searchTypeFieldChanged);
        this._useInitial.removeListener("UserValue", this._useInitialFieldChanged);
        this._useArp.removeListener("UserValue", this._useArpFieldChanged);
        this._vrfName.removeListener("UserValue", this._vrfNameFieldChanged);
        this._useCdp.removeListener("UserValue", this._useCdpFieldChanged);
        this._useLldp.removeListener("UserValue", this._useLldpFieldChanged);

        this._formsComponent.removeListener(
            "PendingPatchesChanged",
            this._onFormsPendingPatchesChanged
        );
        this._formsComponent.removeListener("PristineValueChanged", this._onPristineValueChanged);
        this._mode.removeListener("UserValue", this._modeChange);
        this._selectSeededDevice.removeListener("UserClick", this._selectSeededDeviceClick);
        this._addNewRangeButton.removeListener("UserClick", this._addNewRangeClick);
        this._model.removeListener("UpdateTargetsGrid", this._resetTargetsGrid);
        document.removeEventListener("click", this._clickHandler);
        this._addNewCredButton.removeListener("UserClick", this._addNewCredentialClick);
        this._model.removeListener("UpdateCredentialsGrid", this._resetCredentialsGrid);
        this._addNewExclusionButton.removeListener("UserClick", this._addNewExclusionClick);
        window.removeEventListener("resize", this._fitTableSize);
        this._model.removeListener("ResetView", this._resetView);
        this._model.removeListener("Status", this.updateStatus);
        // this._model.removeListener("Dirty", this._onDirtyState);
        this._model.removeListener("DiscoveryWorkIdUpdated", this._onWorkIdUpdated);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [this._formsComponent.shutdown()];
        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._renderingForm = undefined;
                this._formsComponent = undefined;
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "NetworkDiscoveryDetailsViewRenderer.shutdown() error."
                );
            }
        );
    }

    /**
     * Event Listeners - Start
     */

    // View Actions - Start
    _onSaveDiscovery() {
        this._model
            .saveEntity()
            .then(() => {
                this._setDirty();
            })
            .catch((err) => {
                this._model.displaySaveError(err);
            });
    }

    _onCancelDiscovery() {
        this._model.gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: "Are you sure you want to cancel? All changes will be lost.",
                title: "Cancel Confirmation Check",
                confirmDetails: {
                    text: "Yes",
                    type: "text",
                },
            },
            (this._onDiscoveryDetailsCancelAction = this._onDiscoveryDetailsCancelAction.bind(this))
        );
    }

    async _onScheduleDiscovery() {
        await this._model._scheduleDiscovery();
        this._setDirty();
    }

    async _onRunDiscovery() {
        const action = event.target.innerText;
        this._disableEnableView(true);
        this._model.gameEditor.disableViewAction("RunDiscovery");
        switch (action) {
            case "Run Now":
                this._model._setViewActionText("RunDiscovery", "Starting...");
                await this._model.runNetworkDiscoveryWork();
                this._model.gameEditor.enableViewAction("RunDiscovery");
                break;
            case "Cancel":
                this._model.gameEditor.disableViewAction("RunDiscovery");
                await this._model.cancelNetworkDiscoveryWork();
                this._model.gameEditor.enableViewAction("RunDiscovery");
                break;
        }

        this._disableEnableView(false);
    }
    // View Actions - End

    _disableEnableView(state) {
        this._nameField.setDisabled(state);
        this._descField.setDisabled(state);
        this._engineZone.setDisabled(state);
        this._mode.setDisabled(state);
        // this._formsComponent.setDisabled(state);
        this._searchType.setDisabled(state);
        this._searchDepth.setDisabled(state);
        this._useInitial.setDisabled(state);
        this._useArp.setDisabled(state);
        this._vrfName.setDisabled(state);
        this._useCdp.setDisabled(state);
        this._useLldp.setDisabled(state);

        if (state) {
            this._formsComponent.renderer._rootElem.classList.add("read-only");
            this.rangesSectionBlock.classList.add("read-only");
            this.credentialsSectionBlock.classList.add("read-only");
            this.exclusionsSectionBlock.classList.add("read-only");

            // Set Action Button Text
            this._model._setViewActionText("RunDiscovery", "Cancel");
            this._model.gameEditor.disableViewAction("ScheduleDiscovery");
        } else {
            this._formsComponent.renderer._rootElem.classList.remove("read-only");
            this.rangesSectionBlock.classList.remove("read-only");
            this.credentialsSectionBlock.classList.remove("read-only");
            this.exclusionsSectionBlock.classList.remove("read-only");

            // Set Action Button Text
            this._model._setViewActionText("RunDiscovery", "Run Now");
            this._model.gameEditor.enableViewAction("ScheduleDiscovery");
        }
    }

    _nameFieldChanged() {
        this._setTopEntityFields();
    }
    _descFieldChanged() {
        this._setTopEntityFields();
    }
    _zoneFieldChanged() {
        this._setTopEntityFields();
    }

    _rangesConnectionTypeFieldChanged() {
        if (this._rangesConnectionType.getValue() === "ssh") {
            this._rangesPort.setValue(22);
        } else {
            this._rangesPort.setValue(23);
        }

        this._model._setRangesConnectionFields({
            connectionType: this._rangesConnectionType.getValue() || "ssh",
            port: this._rangesPort.getValue() || 22,
        });

        this._setDirty();
    }
    _rangesPortFieldChanged() {
        this._model._setRangesConnectionFields({
            connectionType: this._rangesConnectionType.getValue() || "ssh",
            port: this._rangesPort.getValue() || 22,
        });

        this._setDirty();
    }

    _searchTypeFieldChanged() {
        this._setOptionsEntity();
    }
    _searchDepthFieldChanged() {
        this._setOptionsEntity();
    }
    _useInitialFieldChanged() {
        this._setOptionsEntity();
    }
    _useArpFieldChanged(val) {
        if (!val) {
            this._vrfName.setValue("");
            this._vrfName._renderer.rootElement.classList.add("read-only");
        } else {
            this._vrfName._renderer.rootElement.classList.remove("read-only");
        }
        this._setOptionsEntity();
    }
    _vrfNameFieldChanged() {
        this._setOptionsEntity();
    }
    _useCdpFieldChanged() {
        this._setOptionsEntity();
    }
    _useLldpFieldChanged() {
        this._setOptionsEntity();
    }

    _onPristineValueChanged() {}

    _onDiscoveryPropertiesChanged() {
        if (!this._model.isDirty) {
            this._resetView();
        } else {
            this._model.gameEditor.runQuickConfirmationActionWorkflow(
                {
                    message:
                        "This Network Discovery has been updated by another user. Do you want to refresh its details? All changes will be lost.",
                    title: "Update Confirmation Check",
                    confirmDetails: {
                        text: "Yes",
                        type: "text",
                    },
                },
                (this._onDiscoveryDetailsCancelAction =
                    this._onDiscoveryDetailsCancelAction.bind(this))
            );
        }
    }

    _onFormsPendingPatchesChanged() {
        const formVal = this._formsComponent.getValue();
        this._model.setConnectionInformation(formVal);

        this._setDirty();
    }

    _modeChange(val) {
        if (!val) {
            val = this._mode.getValue();
        }
        if (val === "CRAWL") {
            this._crawlSectionContainer.classList.remove("hide");
            this._scanSectionContainer.classList.add("hide");
        } else {
            this._crawlSectionContainer.classList.add("hide");
            this._scanSectionContainer.classList.remove("hide");

            this._slickTable.resizeCanvas();
        }

        this._model._setModeValue(val);

        this._setDirty();
    }

    _selectSeededDeviceClick() {
        let manageDevice = new manageDeviceComponent(this._model);
        manageDevice.renderer.render().then(() => {
            this._childViewRenderer = new childViewComponent({
                data: manageDevice.renderer.rootElement,
                backLink: "Details",
                title: "Seeded Device",
                childData: manageDevice,
                parentData: this._model,
                backButton: true,
            });
        });
    }

    _addNewRangeClick() {
        return this._model._modalUserFeedback
            .displayCustom(new AddEditTargetsScreen(this._model._logger, {}, "Add Range"), {
                dontHide: true,
            })
            .then((res) => {
                this._model.addTargets(res);
                return Promise.resolve();
            })
            .then(() => {
                return this._ifIPAddressesMoreThan1024();
            })
            .catch((err) => {
                if (!err.userRejected) {
                    this._logger.warn(
                        {error: err},
                        "NetworkDiscoveryDetailsViewRenderer._addNewRangeClick() error."
                    );
                }
            })
            .finally(() => {
                this._model._modalUserFeedback.hideDisplayed();

                this._setDirty();
            });
    }

    _addNewCredentialClick() {
        return this._model._modalUserFeedback
            .displayCustom(
                new AddEditCredentialsScreen(
                    this._model._logger,
                    {},
                    "Add Credential",
                    this._getCredsForCredentialsScreen()
                ),
                {dontHide: true}
            )
            .then((res) => {
                this._model.addCredentials(res);
                return Promise.resolve();
            })
            .catch((err) => {
                if (!err.userRejected) {
                    this._logger.warn(
                        {error: err},
                        "NetworkDiscoveryDetailsViewRenderer._addNewCredentialClick() error."
                    );
                }
            })
            .finally(() => {
                this._model._modalUserFeedback.hideDisplayed();

                this._setDirty();
            });
    }

    _addNewExclusionClick() {
        this._addEditExclusions();

        this._setDirty();
    }

    async _resetView() {
        this._resetTargetsGrid();
        this._resetCredentialsGrid();
        this._resetExclusionsGrid();

        const pristineProps = this._model._networkDiscoveryPlanEntity.getPristineProperties();
        this._setValues(pristineProps);

        this._modeChange();
        this._useArpFieldChanged(this._useArp.getValue());

        this._formsComponent.setPristineValue(pristineProps.connectionInformation || {});

        await this._formsComponent._renderer.render();

        this._setDirty();

        // this.FormsComponent._renderer.render();
    }

    updateStatus(status) {
        this._setStatusFromPristine(status);
        this._statusField.setValue(status);

        this._disableEnableView(status === "RUNNING");
    }

    _onDirtyState() {
        this._setDirty();
    }

    _onWorkIdUpdated() {
        if (this._model._networkDiscoveryPlanEntity.status === "RUNNING") {
            this._model.gameEditor.enableViewAction("RunDiscovery");
            this._model._setViewActionText("RunDiscovery", "Cancel");
        }
    }

    _resetTargetsGrid() {
        this._slickDataVIew.setItems(this._model._targets);
        this._toggleNoDataPlaceholder(!this._model._targets.length, this._slickTableContainer);
        // this._sortTable();
        this._slickTable.invalidate();

        this._slickTable.render();

        this._slickTable.resizeCanvas();

        this._setDirty();
    }

    _resetCredentialsGrid() {
        this._slickCredentialsDataVIew.setItems(this._model._credentialsSlick);
        this._toggleNoDataPlaceholder(
            !this._model._credentialsSlick.length,
            this._slickCredentialsTableContainer
        );
        // this._sortTable();
        this._slickCredentialsTable.invalidate();

        this._slickCredentialsTable.render();

        this._slickCredentialsTable.resizeCanvas();

        this._setDirty();
    }

    _resetExclusionsGrid() {
        this._slickExclusionsDataVIew.setItems(this._model._exclusionsSlickData);
        this._toggleNoDataPlaceholder(
            !this._model._exclusionsSlickData.length,
            this._slickExclusionsTableContainer
        );
        // this._sortTable();
        this._slickExclusionsTable.invalidate();

        this._slickExclusionsTable.render();

        this._slickExclusionsTable.resizeCanvas();

        this._setDirty();
    }

    _clickHandler(e) {
        const target = e.target.closest("base-icon-gl");

        if (
            target &&
            target.getAttribute("plan-id") === this._model._networkDiscoveryPlanEntity.getId()
        ) {
            if (
                target &&
                target.getAttribute("role") === "button" &&
                target.dataset.action === "delete" &&
                target.dataset.uuid
            ) {
                const currentItem = this._slickDataVIew.getItemById(target.dataset.uuid);

                this.model._modalUserFeedback
                    .displayConfirmation(
                        `Are you sure you want to remove the ${
                            currentItem.type === "ipBlock" ? "IP Block" : "IP Range"
                        } ${currentItem.ipRangeValues}?\n`,
                        {
                            title: "Delete Range",
                            confirmDetails: {
                                text: "OK",
                                type: "destructive",
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text",
                            },
                        }
                    )
                    .then(() => {
                        this._model.removeTargets(target.dataset.uuid);
                    });
            } else if (
                target &&
                target.getAttribute("role") === "button" &&
                target.dataset.action === "edit" &&
                target.dataset.uuid
            ) {
                this._editTargets(target.dataset.uuid);
            } else if (
                target &&
                target.getAttribute("role") === "button" &&
                target.dataset.action === "delete-cred" &&
                target.dataset.uuid
            ) {
                this._model.removeCredential(target.dataset.uuid);
            } else if (
                target &&
                target.getAttribute("role") === "button" &&
                target.dataset.action === "edit-cred" &&
                target.dataset.uuid
            ) {
                this._editCred(target.dataset.uuid);
            } else if (
                target &&
                target.getAttribute("role") === "button" &&
                target.dataset.action === "delete-exclusion" &&
                target.dataset.uuid
            ) {
                const currentItem = this._slickExclusionsDataVIew.getItemById(target.dataset.uuid);

                const itemVal =
                    currentItem.type === "ipRange" && currentItem.exclusionValue
                        ? currentItem.exclusionValue.start + " - " + currentItem.exclusionValue.end
                        : currentItem.type === "deviceType" && currentItem.exclusionValue
                        ? this._model._typeBaseMap[currentItem.exclusionValue]
                        : currentItem.exclusionValue;

                this.model._modalUserFeedback
                    .displayConfirmation(
                        `Are you sure you want to remove the exclusion of the ${
                            this._model._exclusionTypes[currentItem.type]
                        } ${itemVal}?\n`,
                        {
                            title: "Delete Exclusion",
                            confirmDetails: {
                                text: "OK",
                                type: "destructive",
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text",
                            },
                        }
                    )
                    .then(() => {
                        this._model.removeExclusion(target.dataset.uuid);
                    });
            } else if (
                target &&
                target.getAttribute("role") === "button" &&
                target.dataset.action === "edit-exclusion" &&
                target.dataset.uuid
            ) {
                this._editExclusion(target.dataset.uuid);
            }
        }
    }

    /**
     * Event Listeners - End
     */

    /**
     * Getters and Setters : Start
     */

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /**
     * Getters and Setters : End
     */

    /**
     * Render Methods : Start
     */

    render() {
        return this._model
            .whenModelIsReady()
            .then(() => {
                return this._createNetworkDiscoveryForm();
            })
            .then(() => {
                this._disableEnableView(
                    this._model._networkDiscoveryPlanEntity.getStatus() === "RUNNING"
                );
                this._registerListeners();
                this._modeChange();

                this._useArpFieldChanged(this._useArp.getValue());

                this._fitTableSize();
            })
            .catch((err) => {
                this._model._logger.warn({err}, "Error in render:");
            });
    }

    async _createNetworkDiscoveryForm() {
        return Promise.resolve()
            .then(async () => {
                // TOP AREA - START
                const networkDiscoveryTopContainer = document.createElement("div");
                networkDiscoveryTopContainer.classList.add("top-details-container");

                const row1 = this._createRow();
                const row2 = this._createRow();
                const row3 = this._createRow();
                const row4 = this._createRow();

                const name = this._createTextBox("Name *", "_nameField", "left");
                const progress = this._createProgress("Progress", "_progressField", "right");
                const desc = this._createTextBox("Description", "_descField", "left");
                const status = this._createTextBox("Status", "_statusField", "right", true);

                const defaultEngine = this._model._engineZoneDropDownValues.find((i) => i.default);

                const engineZone = this._createComboBox(
                    "Engine Zone",
                    "_engineZone",
                    "left",
                    this._model._engineZoneDropDownValues,
                    !_.isEmpty(this._model._engineZoneDropDownValues) && !_.isEmpty(defaultEngine)
                        ? defaultEngine.value
                        : !_.isEmpty(this._model._engineZoneDropDownValues)
                        ? this._model._engineZoneDropDownValues[0].value
                        : null
                );

                const mode = this._createRadio("Mode", "_mode", "left");

                row1.appendChild(name);
                row1.appendChild(progress);

                row2.appendChild(desc);
                row2.appendChild(status);

                row3.appendChild(engineZone);

                row4.appendChild(mode);

                networkDiscoveryTopContainer.appendChild(row1);
                networkDiscoveryTopContainer.appendChild(row2);
                networkDiscoveryTopContainer.appendChild(row3);
                networkDiscoveryTopContainer.appendChild(row4);
                // TOP AREA - END

                // Crawl section container - Start
                this._crawlSectionContainer = document.createElement("div");
                this._crawlSectionContainer.classList.add("crawl-section-container");
                // Crawl section container - Start

                // Crawl Section content - Start
                // Seeded device - Start
                const seededBorderedArea = this._createBorderedSection(
                    "Seeded Device",
                    "seeded-device"
                );
                seededBorderedArea.appendChild(await this._createSeededDeviceSection());
                // Seeded device - End

                // Options - Start
                const optionsBorderedArea = this._createBorderedSection(
                    "Options",
                    "options-section"
                );
                optionsBorderedArea.appendChild(this._createOptionsSection());
                // Options - End
                // Crawl Section content - End

                // Scan Section container - Start
                this._scanSectionContainer = document.createElement("div");
                this._scanSectionContainer.classList.add("scan-section-container");
                // Scan Section container - End

                // Scan Section content - Start
                const rangesSection = this._createBorderedSection("Ranges *", "ranges-section");
                rangesSection.appendChild(this._createRangesSection());
                // Scan Section content - End

                // Add sections to Crawl container - Start
                this._crawlSectionContainer.appendChild(seededBorderedArea);
                this._crawlSectionContainer.appendChild(optionsBorderedArea);
                // Add sections to Crawl container - End

                // Add sections to Crawl container - Start
                this._scanSectionContainer.appendChild(rangesSection);
                // Add sections to Crawl container - End

                // Credentials Section - Start
                const credentialsSection = this._createBorderedSection(
                    "Credentials *",
                    "credentials-section"
                );
                credentialsSection.appendChild(this._createCredentialsSection());
                // Credentials Section - End

                // Credentials Section - Start
                const exclusionsSection = this._createBorderedSection(
                    "Exclusions",
                    "exclusions-section"
                );
                exclusionsSection.appendChild(this._createExclusionsSection());
                // Credentials Section - End

                this._setValues(this._model._networkDiscoveryPlanEntity.getPristineProperties());

                this._rootElem.appendChild(networkDiscoveryTopContainer);
                this._rootElem.appendChild(this._crawlSectionContainer);
                this._rootElem.appendChild(this._scanSectionContainer);
                this._rootElem.appendChild(credentialsSection);
                this._rootElem.appendChild(exclusionsSection);

                this._populateGrids();

                await this._setTopValuesIfNeeded();
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }

    // Crawl Section - START

    // Seeded Device Section - Start

    async _createSeededDeviceSection() {
        try {
            const seededDeviceContainer = document.createElement("div");
            seededDeviceContainer.classList.add("seeded-device-container");

            this._connectionInformationContainer = document.createElement("div");
            this._connectionInformationContainer.classList.add("connection-info-container");
            this._connectionInformationContainer.appendChild(
                this._formsComponent._renderer._rootElem
            );

            const jType = _.get(this._model._connectionInfoJtype, [
                "selectOptions",
                "connectionType@Select.options",
                "cliConnection",
            ]);

            Object.assign(jType, _.get(this._model._connectionInfoJtype, ["typeDefs"]));

            this._formsComponent.setTypeInformation(jType, true);
            this._formsComponent.setPristineValue(
                this._model._networkDiscoveryPlanEntity.getConnectionInformation() || {},
                true
            );

            await this._formsComponent.renderer.render();

            this._selectSeededDevice = new Button({
                label: "Select Seeded Device",
            });

            seededDeviceContainer.appendChild(this._connectionInformationContainer);
            seededDeviceContainer.appendChild(this._selectSeededDevice._renderer._rootElem);

            return seededDeviceContainer;
        } catch (err) {
            return Promise.reject(err);
        }
    }

    async _createConnectionTypeBlock() {
        const connectionTypeContainer = document.createElement("div");
        connectionTypeContainer.classList.add("connection-type-container");
        connectionTypeContainer.appendChild(this._formsComponent._renderer._rootElem);

        const jType = _.get(this._model._connectionInfoJtype, [
            "selectOptions",
            "connectionType@Select.options",
            "cliConnection",
        ]);

        this._formsComponent.setTypeInformation(jType, true);
        this._formsComponent.setPristineValue({}, true);

        await this._formsComponent.renderer.render();

        return connectionTypeContainer;
    }

    // Seeded Device Section - End

    // Options Section - Start

    /**
     *
     * @returns Options Section HTML Element
     */
    _createOptionsSection() {
        const optionsContainer = document.createElement("div");
        optionsContainer.classList.add("options-container");

        const searchTypeOptions = _.entries(
            this._model._networkDiscoveryPlanEntity.getSearchTypeLabels()
        ).map(([key, value]) => ({
            label: value,
            value: key,
        }));

        const row1 = this._createRow();

        const searchType = this._createComboBox(
            "Search Type",
            "_searchType",
            "left",
            searchTypeOptions,
            "LIMITED"
        );
        const searchDepth = this._createNumericTextBox("Search Depth", "_searchDepth", "right");

        const initialIP = this._createCheckBox("Use Initial IP as Proxy", "_useInitial", "full");

        const borderedSearchMethods = this._createBorderedSection(
            "Search Methods *",
            "search-methods-container"
        );
        borderedSearchMethods.appendChild(this._createSearchMethods());

        row1.appendChild(searchType);
        row1.appendChild(searchDepth);

        optionsContainer.appendChild(row1);
        optionsContainer.appendChild(initialIP);
        optionsContainer.appendChild(borderedSearchMethods);

        return optionsContainer;
    }

    /**
     *
     * @returns Search Methods section HTML Element
     */
    _createSearchMethods() {
        const searchMethodsContainer = document.createElement("div");
        searchMethodsContainer.classList.add("search-methods-container");

        const row1 = this._createRow();
        const useARP = this._createCheckBox("Use ARP in VRF", "_useArp", "left");
        const vrfName = this._createTextBox("VRF Name", "_vrfName", "right", false, true);
        row1.appendChild(useARP);
        row1.appendChild(vrfName);

        const useCDP = this._createCheckBox("Use CDP", "_useCdp", "left");
        const useLLDB = this._createCheckBox("Use LLDP", "_useLldp", "left");

        searchMethodsContainer.appendChild(row1);
        searchMethodsContainer.appendChild(useCDP);
        searchMethodsContainer.appendChild(useLLDB);

        return searchMethodsContainer;
    }

    // Options Section - End

    // Crawl Section - END

    // Scan Section - START

    _createRangesSection() {
        this.rangesSectionBlock = document.createElement("div");
        this.rangesSectionBlock.classList.add("ranges-section-container");

        const gridContainer = document.createElement("div");
        gridContainer.classList.add("ranges-grid-container");

        this._slickTableContainer = document.createElement("slick-table-discovery");
        this._slickTable = undefined;

        this._slickDataVIew = new Slick.Data.DataView();

        const rangesSectionLower = document.createElement("div");
        rangesSectionLower.classList.add("ranges-section-lower");

        const rangesConnTypeOptions = [
            {label: "ssh", value: "ssh"},
            {label: "telnet", value: "telnet"},
        ];
        const rangesConnType = this._createComboBox(
            "Connection Type",
            "_rangesConnectionType",
            "ranges-connection-type",
            rangesConnTypeOptions,
            "ssh"
        );
        const rangesPort = this._createNumericTextBox("Port", "_rangesPort", "ranges-port", false);
        rangesSectionLower.appendChild(rangesConnType);
        rangesSectionLower.appendChild(rangesPort);

        this._addNewRangeButton = new Button({
            label: "Add Range +",
            active: true,
        });

        gridContainer.appendChild(this._slickTableContainer);
        gridContainer.appendChild(this._addNewRangeButton._renderer._rootElem);

        this.rangesSectionBlock.appendChild(gridContainer);
        this.rangesSectionBlock.appendChild(rangesSectionLower);

        return this.rangesSectionBlock;
    }

    // Scan Section - END

    // Credentials Section - Start

    _createCredentialsSection() {
        this.credentialsSectionBlock = document.createElement("div");
        this.credentialsSectionBlock.classList.add("credentials-section-container");

        const gridContainer = document.createElement("div");
        gridContainer.classList.add("credentials-grid-container");

        this._slickCredentialsTableContainer = document.createElement("slick-table-discovery");

        this._addNewCredButton = new Button({
            label: "Add Credential +",
            active: true,
        });

        gridContainer.appendChild(this._slickCredentialsTableContainer);
        gridContainer.appendChild(this._addNewCredButton._renderer._rootElem);

        this.credentialsSectionBlock.appendChild(gridContainer);

        return this.credentialsSectionBlock;
    }

    // Credentials Section - End

    // Exclusions Section - Start

    _createExclusionsSection() {
        this.exclusionsSectionBlock = document.createElement("div");
        this.exclusionsSectionBlock.classList.add("exclusions-section-container");

        const gridContainer = document.createElement("div");
        gridContainer.classList.add("exclusion-grid-container");

        this._slickExclusionsTableContainer = document.createElement("slick-table-discovery");
        this._slickExclusionsTable = undefined;

        this._addNewExclusionButton = new Button({
            label: "Add Exclusion +",
            active: true,
        });

        gridContainer.appendChild(this._slickExclusionsTableContainer);
        gridContainer.appendChild(this._addNewExclusionButton._renderer._rootElem);

        this.exclusionsSectionBlock.appendChild(gridContainer);

        return this.exclusionsSectionBlock;
    }

    // Exclusions Section - End

    /**
     * Render Methods : End
     */

    /**
     * Create Sections - Start
     */

    _createRow() {
        const row = document.createElement("div");
        row.classList.add("row");

        return row;
    }

    _createTextBox(label, fieldName, additionalClass = "", isReadOnly = false, hideLabel = false) {
        const textBoxContainer = document.createElement("div");
        textBoxContainer.classList.add(
            `${label.replaceAll(" ", "-").toLowerCase()}-container`,
            "text-box-container",
            additionalClass
        );

        this[fieldName] = new InputText({
            darkTheme: false,
            placeholder: label,
            value: "",
        });

        if (isReadOnly) {
            this[fieldName].setDisabled(true);
        }

        if (!hideLabel) {
            const lbl = document.createElement("label");
            lbl.innerText = label;

            textBoxContainer.appendChild(lbl);
        }

        textBoxContainer.appendChild(this[fieldName]._renderer._rootElem);

        return textBoxContainer;
    }

    _createNumericTextBox(label, fieldName, additionalClass = "", isReadOnly = false) {
        const textBoxContainer = document.createElement("div");
        textBoxContainer.classList.add(
            `${label.replaceAll(" ", "-").toLowerCase()}-container`,
            "text-box-container",
            additionalClass
        );

        const lbl = document.createElement("label");
        lbl.innerText = label;
        this[fieldName] = new InputNumber({
            darkTheme: false,
            placeholder: label,
            value: 0,
        });

        if (isReadOnly) {
            this[fieldName].setDisabled(true);
        }

        textBoxContainer.appendChild(lbl);
        textBoxContainer.appendChild(this[fieldName]._renderer._rootElem);

        return textBoxContainer;
    }

    _createProgress(label, fieldName, additionalClass = "") {
        const progressContainer = document.createElement("div");
        progressContainer.classList.add(
            `${label.replaceAll(" ", "-").toLowerCase()}-container`,
            "status-flow-container",
            additionalClass
        );

        const lbl = document.createElement("label");
        lbl.innerText = label;
        this[fieldName] = new StatusFlow({});

        progressContainer.appendChild(lbl);
        progressContainer.appendChild(this[fieldName]._renderer._rootElem);

        return progressContainer;
    }

    _createComboBox(label, fieldName, additionalClass, options = [], defaultVal = undefined) {
        const cmbBoxContainer = document.createElement("div");
        cmbBoxContainer.classList.add(
            `${label.replaceAll(" ", "-").toLowerCase()}-container`,
            "combo-box-container",
            additionalClass
        );

        const lbl = document.createElement("label");
        lbl.innerText = label;
        this[fieldName] = new ComboBox({
            darkTheme: false,
            placeholder: label,
            required: true,
            options: options || [],
        });

        if (defaultVal) {
            this[fieldName].setValue(defaultVal);
        }

        cmbBoxContainer.appendChild(lbl);
        cmbBoxContainer.appendChild(this[fieldName]._renderer._rootElem);

        return cmbBoxContainer;
    }

    _createCheckBox(label, fieldName, additionalClass) {
        const chkBoxContainer = document.createElement("div");
        chkBoxContainer.classList.add(
            `${label.replaceAll(" ", "-").toLowerCase()}-container`,
            "check-box-container",
            additionalClass
        );

        this[fieldName] = new InputCheckbox({
            label: label,
            labelShown: true,
            value: false,
            darkTheme: true,
        });

        chkBoxContainer.appendChild(this[fieldName]._renderer._rootElem);

        return chkBoxContainer;
    }

    _createRadio(label, fieldName, additionalClass) {
        const radioBtnContainer = document.createElement("div");
        radioBtnContainer.classList.add(
            `${label.replaceAll(" ", "-").toLowerCase()}-container`,
            "combo-box-container",
            additionalClass
        );

        const lbl = document.createElement("label");
        lbl.innerText = label;

        this[fieldName] = new InputRadio({
            labelShown: true,
            horizontal: true,
            options: [
                {label: "Neighbor Crawl", value: "CRAWL"},
                {label: "Subnet Scan", value: "SCAN"},
            ],
            value: "CRAWL",
            label: label,
        });

        radioBtnContainer.appendChild(lbl);
        radioBtnContainer.appendChild(this[fieldName]._renderer._rootElem);

        return radioBtnContainer;
    }

    _createBorderedSection(title, className = "") {
        const borderedSection = document.createElement("div");
        borderedSection.classList.add("bordered", className);

        const titleSpan = document.createElement("span");
        titleSpan.classList.add("title-for-bordered-section");
        titleSpan.innerText = title;

        borderedSection.appendChild(titleSpan);

        return borderedSection;
    }

    /**
     * Create Sections - End
     */

    /**
     * Helper Methods : Start
     */

    _setTopValuesIfNeeded() {
        if (!this._model._newPlanNoEngineZone) {
            if (
                this._model._networkDiscoveryPlanEntity.getEngineZoneId() !==
                this._engineZone.getValue()
            ) {
                this._setTopEntityFields();

                return this._model._modalUserFeedback.displayNotification(
                    "The EngineZone has changed due to some changes to the system. Please make necessary changes.",
                    {
                        notDismissable: true,
                        title: "Engine Zone Changed",
                        confirmDetails: {text: "OK"},
                    }
                );
            }
        }
    }

    _onDiscoveryDetailsCancelAction() {
        this._model._resetView();
    }

    _setDirty() {
        const patches = this._model._networkDiscoveryPlanEntity.getPendingPatches();
        if (
            !_.isEmpty(patches) &&
            patches.length === 1 &&
            patches[0].path === "/status" &&
            patches[0].value === "DRAFT"
        ) {
            this._model._networkDiscoveryPlanEntity.clearPendingPatches(true);
        }

        const dirtyState = this._model.isDirty;
        this._model._gameEditor._setDirty(dirtyState);

        if (dirtyState) {
            if (this._isFormValid()) {
                this._model._setStatus("DRAFT");
                this._setStatusFromPristine("DRAFT");
                this._model.gameEditor.enableViewAction("SaveDiscovery");
                this._model.gameEditor.disableViewAction("RunDiscovery");
                this._model.gameEditor.disableViewAction("ScheduleDiscovery");
                this._model.gameEditor.enableViewAction("CancelDiscovery");
            } else {
                this._model._setStatus("DRAFT");
                this._setStatusFromPristine("DRAFT");
                this._model.gameEditor.disableViewAction("SaveDiscovery");
                this._model.gameEditor.disableViewAction("RunDiscovery");
                this._model.gameEditor.disableViewAction("ScheduleDiscovery");
                this._model.gameEditor.enableViewAction("CancelDiscovery");
            }
        } else {
            if (this._isFormValid()) {
                if (this._model._networkDiscoveryPlanEntity.getStatus() !== "RUNNING") {
                    this._setStatusFromPristine(
                        this._model._networkDiscoveryPlanEntity.getStatus()
                    );
                    this._model.gameEditor.disableViewAction("SaveDiscovery");
                    this._model.gameEditor.enableViewAction("RunDiscovery");
                    this._model.gameEditor.enableViewAction("ScheduleDiscovery");
                    this._model.gameEditor.disableViewAction("CancelDiscovery");
                } else {
                    this._setStatusFromPristine(
                        this._model._networkDiscoveryPlanEntity.getStatus()
                    );
                    this._model.gameEditor.disableViewAction("SaveDiscovery");
                    this._model.gameEditor.enableViewAction("RunDiscovery");
                    this._model.gameEditor.disableViewAction("ScheduleDiscovery");
                    this._model.gameEditor.disableViewAction("CancelDiscovery");
                }
            } else {
                this._model._setStatus("DRAFT");
                this._setStatusFromPristine("DRAFT");
                this._model.gameEditor.disableViewAction("SaveDiscovery");
                this._model.gameEditor.disableViewAction("RunDiscovery");
                this._model.gameEditor.disableViewAction("ScheduleDiscovery");
                this._model.gameEditor.disableViewAction("CancelDiscovery");
            }
        }
    }

    _setValues(pristineValues) {
        this._nameField.setValue(pristineValues.name);
        this._descField.setValue(pristineValues.description || "");
        this._setStatusFromPristine(pristineValues.status);
        this._statusField.setValue(pristineValues.status);
        if (
            !_.isEmpty(pristineValues.engineZoneId) &&
            !_.isEmpty(
                (this._engineZone.getOptions() || []).find(
                    (i) => i.value === pristineValues.engineZoneId
                )
            )
        ) {
            this._engineZone.setValue(pristineValues.engineZoneId);
        }

        this._mode.setValue(pristineValues.mode || "CRAWL");

        this._rangesConnectionType.setValue(pristineValues.connectionType || "ssh");
        this._rangesPort.setValue(pristineValues.scanPort || 22);

        if (!_.isEmpty(pristineValues.searchType)) {
            this._searchType.setValue(pristineValues.searchType);
        }
        this._searchDepth.setValue(pristineValues.searchDepth || 3);
        this._useInitial.setValue(pristineValues.useAsProxy);

        this._useArp.setValue(pristineValues.useArp);
        this._vrfName.setValue(pristineValues.vrf);

        this._useCdp.setValue(pristineValues.useCdp);
        this._useLldp.setValue(pristineValues.useLldp);
    }

    _setStatusFromPristine(status) {
        this._statusField.setValue(status);
        switch (status) {
            case "DRAFT":
                this._setStatus("Draft", "default");
                this._setStatus("Run", "default");
                break;
            case "READY":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "default");
                break;
            case "CANCELED":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "canceled");
                break;
            case "ERROR":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "error");
                break;
            case "CANCELING":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "canceling");
                break;
            case "RUNNING":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "running");
                break;
            case "COMPLETE":
            case "SUCCESS":
                this._setStatus("Draft", "ready");
                this._setStatus("Run", "success");
                break;
        }
    }

    _setStatus(state, status) {
        if (this._progressField) {
            this._progressField.setState(state, status);
        }
    }

    _isFormValid() {
        let valid = true;
        const connectionInfo = this._formsComponent.getValue();
        valid =
            _.isEmpty(_.trim(this._nameField.getValue() || "")) !== "" &&
            !_.isEmpty(this._model._credentialsSlick);

        if (valid && this._mode.getValue() === "CRAWL") {
            valid =
                !_.isEmpty(connectionInfo.ip) &&
                this._validateIp(_.trim(connectionInfo.ip)).valid &&
                !_.isEmpty(connectionInfo.type) &&
                _.inRange(connectionInfo.port, 1, 99) &&
                !_.isEmpty(connectionInfo.credentials) &&
                this._oneOfTheSearchMethodsIsTrue();
        } else if (valid && this._mode.getValue() === "SCAN") {
            valid = !_.isEmpty(this._model._targets);
        }

        if (valid) {
            this._model._isPlanValid = true;
        } else {
            this._model._isPlanValid = false;
        }

        return valid;
    }

    _oneOfTheSearchMethodsIsTrue() {
        return this._useArp.getValue() || this._useCdp.getValue() || this._useLldp.getValue();
    }

    _validateIp(val) {
        let ipType;
        const v4expression =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if (v4expression.test(val)) {
            ipType = 4;
            return {
                ipType,
                valid: true,
            };
        }
        const v6expression = /^([0-9A-Fa-f]{1,4}::?){1,7}[0-9A-Fa-f]{1,4}$/;
        if (v6expression.test(val)) {
            ipType = 6;
            return {
                ipType,
                valid: true,
            };
        }
        return {
            ipType,
            valid: false,
        };
    }

    _setTopEntityFields() {
        const engineZoneObj =
                this._model._engineZoneDropDownValues.find(
                    (i) => i.value === this._engineZone.getValue()
                ) || {},
            engineZoneName = engineZoneObj.label;

        this._model._setTopEntityFields({
            name: this._nameField.getValue(),
            description: this._descField.getValue(),
            engineZone: this._engineZone.getValue(),
            engineZoneName: engineZoneName,
        });

        this._setDirty();
    }

    _setOptionsEntity() {
        this._model.setOptionsSectionEntityFields({
            searchType: this._searchType.getValue(),
            searchDepth: this._searchDepth.getValue(),
            useAsProxy: this._useInitial.getValue(),
            useArp: this._useArp.getValue(),
            vrf: this._vrfName.getValue(),
            useCdp: this._useCdp.getValue(),
            useLldp: this._useLldp.getValue(),
        });

        this._setDirty();
    }

    _hideViewActions() {
        this._model._gameEditor.hideViewAction("SaveDiscovery");
        this._model._gameEditor.hideViewAction("CancelDiscovery");
        this._model._gameEditor.hideViewAction("ScheduleDiscovery");
        this._model._gameEditor.hideViewAction("RunDiscovery");
    }

    _hideLeftFooterContainer() {
        let leftSelector = document.querySelector("left-container");
        leftSelector.style.display = "none";
    }

    _showViewActions() {
        this._model._gameEditor.showViewAction("SaveDiscovery");
        this._model._gameEditor.showViewAction("CancelDiscovery");
        this._model._gameEditor.showViewAction("ScheduleDiscovery");
        this._model._gameEditor.showViewAction("RunDiscovery");
    }

    _showLeftFooterContainer() {}

    _refreshGrid() {}

    _editTargets(id) {
        const currentItem = this._model._targets.find((item) => `${item.id}` === id);
        return this._model._modalUserFeedback
            .displayCustom(
                new AddEditTargetsScreen(this._model._logger, currentItem, "Edit Range"),
                {dontHide: true}
            )
            .then((res) => {
                this._model.updateTarget(id, res);
                return Promise.resolve();
            })
            .then(() => {
                return this._ifIPAddressesMoreThan1024();
            })
            .catch((err) => {
                if (!err.userRejected) {
                    this._logger.warn(
                        {error: err},
                        "NetworkDiscoveryDetailsViewRenderer._addNewRangeClick() error."
                    );
                }
            })
            .finally(() => {
                this._model._modalUserFeedback.hideDisplayed();

                this._setDirty();
            });
    }

    _ifIPAddressesMoreThan1024() {
        let _IPCount = 0;
        this._model._targets.forEach((target) => {
            _IPCount += this._isValidIPRangeOrBlock(target.ipRangeValues);
        });

        if (_IPCount > 1024) {
            return this._model._modalUserFeedback.displayNotification(
                "The number of IP addresses exceeds the maximum limit of 1024. Please adjust your ranges.",
                {
                    notDismissable: true,
                    title: "IP Address Limit Exceeded",
                    confirmDetails: {text: "OK"},
                }
            );
        }
    }

    _editCred(id) {
        const currentItem = this._model._credentialsSlick.find((item) => `${item.id}` === id);

        return this._model._modalUserFeedback
            .displayCustom(
                new AddEditCredentialsScreen(
                    this._model._logger,
                    currentItem,
                    "Edit Credential",
                    this._getCredsForCredentialsScreen(currentItem.credValue)
                ),
                {dontHide: true}
            )
            .then((res) => {
                this._model.updateCredential(id, res);
                return Promise.resolve();
            })
            .catch((err) => {
                if (!err.userRejected) {
                    this._logger.warn(
                        {error: err},
                        "NetworkDiscoveryDetailsViewRenderer._addNewRangeClick() error."
                    );
                }
            })
            .finally(() => {
                this._model._modalUserFeedback.hideDisplayed();
                this._setDirty();
            });
    }

    _getCredsForCredentialsScreen(skipCred) {
        const usedList = this._model._credentialsSlick.map((cred) => cred.credValue);
        let enableMode = [];
        let deviceUserPass = [];
        if (skipCred && typeof skipCred === "string") {
            enableMode = this._model._enableMode.filter(
                (cred) => usedList.indexOf(cred.label) < 0 || cred.label === skipCred
            );
            deviceUserPass = this._model._deviceUserPass.filter(
                (cred) => usedList.indexOf(cred.label) < 0 || cred.label === skipCred
            );
        } else {
            enableMode = this._model._enableMode.filter((cred) => usedList.indexOf(cred.label) < 0);
            deviceUserPass = this._model._deviceUserPass.filter(
                (cred) => usedList.indexOf(cred.label) < 0
            );
        }
        return {
            enableMode,
            deviceUserPass,
        };
    }

    _editExclusion(id) {
        const item = this._slickExclusionsDataVIew.getItemById(id);
        this._addEditExclusions(item);
    }

    _addEditExclusions(item = {}) {
        const obj = {
            exclusionEntity: this._model._networkDiscoveryExclusionEntity,
            orgId: this._model.activeOrgId,
            muf: this._model._modalUserFeedback,
            item,
            exclusionTypes: this._model._exclusionTypes,
            typeBaseMap: this._model._typeBaseMap,
            parent: this,
        };

        const createEditExclusionComponent = new createEditExclusion(obj);

        return this._model._modalUserFeedback
            .displayCustom(createEditExclusionComponent, {notDismissable: false})
            .then((res) => {
                if (_.isEmpty(item)) {
                    this._model._addExclusion(res);
                } else {
                    this._model._updateExclusion(item.id, res);
                }
            })
            .catch((error) => {
                if (error && error.userRejected === true) {
                    //the veil just has been closed
                    return;
                }
                return error && console.error(error);
            })
            .finally(() => {
                this._setDirty();
            });
    }

    // Methods to check if IP Blocks and ranges are over 1024
    _ipToNumber(ip) {
        return ip.split(".").reduce((acc, octet) => acc * 256 + parseInt(octet, 10), 0);
    }

    _isValidIPRangeOrBlock(input) {
        const rangeRegex = /^(\d{1,3}(?:\.\d{1,3}){3})\s*-\s*(\d{1,3}(?:\.\d{1,3}){3})$/;
        const cidrRegex = /^(\d{1,3}(?:\.\d{1,3}){3})\/(\d{1,2})$/;
        const ipv6SubnetRegex =
            /^([0-9A-Fa-f]{1,4}::?){1,7}[0-9A-Fa-f]{1,4}?s*(\/(12[0-8]|1[0-1][0-9]|[1-9][0-9]|[0-9]))$/;

        if (rangeRegex.test(input)) {
            const match = input.match(rangeRegex);
            const startIP = match[1];
            const endIP = match[2];
            const startIPNumber = this._ipToNumber(startIP);
            const endIPNumber = this._ipToNumber(endIP);
            const ipCount = endIPNumber - startIPNumber + 1;
            return ipCount;
        } else if (cidrRegex.test(input)) {
            const match = input.match(cidrRegex);
            const prefixLength = parseInt(match[2], 10);
            const ipCount = Math.pow(2, 32 - prefixLength);
            return ipCount;
        } else if (ipv6SubnetRegex.test(input)) {
            const match = input.match(ipv6SubnetRegex);
            const prefixLength = parseInt(match[3], 10);
            const ipCount = Math.pow(2, 128 - prefixLength);
            return ipCount;
        } else {
            throw new Error("Invalid input format");
        }
    }

    /**
     * Helper Methods : End
     */

    /**
     * Slick Methods - Start
     */

    // Generic - Start

    _createNoDataPlaceholder(msg = "") {
        const noDataPlaceholder = document.createElement("div");
        noDataPlaceholder.classList.add("no-data-placeholder");
        noDataPlaceholder.innerText = msg || "No Data";
        return noDataPlaceholder;
    }

    _toggleNoDataPlaceholder(state, container) {
        container.classList.toggle("empty", state);
    }

    _fitTableSize() {
        if (this._slickTable) {
            this._slickTable.invalidate();
            this._slickTable.render();
            this._resizeTargetsWithDelay();
        }
        if (this._slickCredentialsTable) {
            this._slickCredentialsTable.invalidate();
            this._slickCredentialsTable.render();
            this._resizeCredentialsWithDelay();
        }
        if (this._slickExclusionsTable) {
            this._slickExclusionsTable.invalidate();
            this._slickExclusionsTable.render();
            this._resizeExclusionsWithDelay();
        }
    }

    _resizeTargetsWithDelay() {
        this._slickTable.resizeCanvas();
        this._slickTable.autosizeColumns();
    }
    _resizeCredentialsWithDelay() {
        this._slickCredentialsTable.resizeCanvas();
        this._slickCredentialsTable.autosizeColumns();
    }
    _resizeExclusionsWithDelay() {
        this._slickExclusionsTable.resizeCanvas();
        this._slickExclusionsTable.autosizeColumns();
    }

    _registerRowMovePlugin(grid, dataView) {
        const moveRowsPlugin = new Slick.RowMoveManager({
            cancelEditOnDrag: true,
        });
        // const sortingComparator = this._model.CustomFieldsEntity.getSortingComparator("order");

        moveRowsPlugin.onBeforeMoveRows.subscribe(function (e, {insertBefore, rows}) {
            rows = [...rows].sort();
            if (
                _.first(rows) === insertBefore ||
                _.last(rows) === insertBefore - 1
                // _.get(dataView.getItem(insertBefore), "inherited")
            ) {
                e.stopPropagation();
                return false;
            }
            return true;
        });
        moveRowsPlugin.onMoveRows.subscribe((e, args) => {
            let extractedRows = [],
                left,
                right;
            let rows = args.rows;
            let insertBefore = args.insertBefore;
            let data = dataView.getItems();
            left = data.slice(0, insertBefore);
            right = data.slice(insertBefore, data.length);

            rows.sort(function (a, b) {
                return a - b;
            });

            for (let i = 0; i < rows.length; i++) {
                extractedRows.push(data[rows[i]]);
            }

            rows.reverse();

            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];
                if (row < insertBefore) {
                    left.splice(row, 1);
                } else {
                    right.splice(row - insertBefore, 1);
                }
            }

            data = left.concat(extractedRows.concat(right));

            let selectedRows = [];
            for (let i = 0; i < rows.length; i++) {
                selectedRows.push(left.length + i);
            }
            dataView.setItems(data);

            grid.resetActiveCell();
            grid.setSelectedRows(selectedRows);
            grid.invalidateAllRows();
            grid.resizeCanvas();

            this._model._credentialsSlick = dataView.getItems();
            this._model._convertCredentialsSlickToEntity();

            this._setDirty();
        });

        grid.registerPlugin(moveRowsPlugin);
    }

    _populateGrids() {
        try {
            this._populateTargetsGrid();
            this._populateCredentialsGrid();
            this._populateExclusionsGrid();
        } catch (err) {
            console.log(err);
        }
    }

    // Generic - End

    // Populate Grids - Start

    _populateTargetsGrid() {
        // this._slickDataVIew.setItems([{id: 1, ipType: "TypeTest", ipRangeValues: "10.1.2.3", actions: "test"}]);

        this._slickDataVIew.setItems(this._model._targets);
        const columns = [
            {
                id: "type",
                width: 500,
                field: "type",
                name: "Type",
                tooltip: "Type",
                selectable: false,
                resizable: false,
                formatter: formatters.ipTypeValueFormatter,
            },
            {
                id: "ipRangeValues",
                width: 2000,
                name: "Values",
                field: "ipRangeValues",
                tooltip: "Values",
                selectable: false,
                resizable: true,
                formatter: formatters.defaultValueFormatter,
            },
            {
                id: "actions",
                name: "Actions",
                field: "actions",
                selectable: false,
                resizable: false,
                headerCssClass: "centered",
                formatter: formatters.deleteButtonFormatter,
                planId: this._model._networkDiscoveryPlanEntity.getId(),
            },
        ];
        this._slickTable = new Slick.Grid(
            this._slickTableContainer,
            this._slickDataVIew,
            columns,
            this._tableOptions
        );

        this._slickTableContainer.appendChild(
            this._createNoDataPlaceholder("No Ranges configured")
        );

        this._toggleNoDataPlaceholder(!this._model._targets.length, this._slickTableContainer);
        this._slickTable.invalidate();
        this._slickTable.render();
        this._slickTable.resizeCanvas();
        this._slickTable.autosizeColumns();
    }

    _populateCredentialsGrid() {
        this._slickCredentialsTable = undefined;

        const columns = [
            {
                id: "order",
                width: 10,
                name: "",
                //field: "order",
                behavior: "selectAndMove",
                asyncPostRender: function (node) {
                    node[0].setAttribute("title", "Reorder");
                },
                selectable: false,
                resizable: true,
                cssClass: "cell-reorder dnd centered g-icon-drag",
                headerCssClass: "centered",
            },
            {
                id: "type",
                field: "type",
                name: "Type",
                tooltip: "Type",
                width: 400,
                selectable: false,
                resizable: true,
                formatter: formatters.credTypeFormatter,
            },
            {
                id: "credValue",
                name: "Credential",
                field: "credValue",
                tooltip: "Credential",
                width: 1300,
                selectable: false,
                resizable: true,
                formatter: formatters.defaultValueFormatter,
            },
            {
                id: "actionsCredentials",
                name: "Actions",
                field: "actionsCredentials",
                selectable: false,
                resizable: true,
                headerCssClass: "centered",
                formatter: formatters.deleteButtonFormatter,
                planId: this._model._networkDiscoveryPlanEntity.getId(),
            },
        ];
        this._maxSortOrder = 0;
        this._slickCredentialsDataVIew = new Slick.Data.DataView();
        this._slickCredentialsDataVIew.setItems(this._model._credentialsSlick);

        this._slickCredentialsTable = new Slick.Grid(
            this._slickCredentialsTableContainer,
            this._slickCredentialsDataVIew,
            columns,
            this._tableOptions
        );

        this._slickCredentialsTable.maxSortOrder = this._maxSortOrder;
        this._slickCredentialsTable.setSelectionModel(new Slick.RowSelectionModel());
        this._registerRowMovePlugin(this._slickCredentialsTable, this._slickCredentialsDataVIew);

        this._slickCredentialsTableContainer.appendChild(
            this._createNoDataPlaceholder("No Credentials configured")
        );

        // this._slickDataVIew.setItems([]);
        this._toggleNoDataPlaceholder(
            !this._model._credentialsSlick.length,
            this._slickCredentialsTableContainer
        );
        this._slickCredentialsTable.invalidate();
        this._slickCredentialsTable.render();
        this._slickCredentialsTable.resizeCanvas();
        this._slickCredentialsTable.autosizeColumns();
    }

    _populateExclusionsGrid() {
        const columns = [
            {
                id: "type",
                width: 200,
                field: "type",
                name: "Type",
                tooltip: "Type",
                selectable: false,
                resizable: true,
                formatter: formatters.exclusionTypeFormatter,
                context: {
                    types: this._model._exclusionTypes,
                },
            },
            {
                id: "description",
                width: 600,
                name: "Description",
                field: "description",
                tooltip: "Description",
                selectable: false,
                resizable: true,
                formatter: formatters.defaultValueFormatter,
            },
            {
                id: "exclusionValue",
                width: 400,
                name: "Values",
                field: "exclusionValue",
                tooltip: "Values",
                selectable: false,
                resizable: true,
                formatter: formatters.exclusionValueFormatter,
            },
            {
                id: "actionsExclusions",
                name: "Actions",
                field: "actionsExclusions",
                width: 100,
                selectable: false,
                resizable: true,
                headerCssClass: "centered",
                formatter: formatters.deleteButtonFormatter,
                planId: this._model._networkDiscoveryPlanEntity.getId(),
            },
        ];

        this._slickExclusionsDataVIew = new Slick.Data.DataView();
        this._slickExclusionsDataVIew.setItems(this._model._exclusionsSlickData);

        this._slickExclusionsTable = new Slick.Grid(
            this._slickExclusionsTableContainer,
            this._slickExclusionsDataVIew,
            columns,
            this._tableOptions
        );

        this._slickExclusionsTableContainer.appendChild(
            this._createNoDataPlaceholder("No Exclusions configured")
        );

        this._toggleNoDataPlaceholder(
            !this._model._exclusionsSlickData.length,
            this._slickExclusionsTableContainer
        );
        this._slickExclusionsTable.invalidate();
        this._slickExclusionsTable.render();
        this._slickExclusionsTable.resizeCanvas();
        this._slickExclusionsTable.autosizeColumns();
    }

    // Populate Grids - End

    /**
     * Slick Methods - End
     */

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE ACTION METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _toLocaleString(val) {
        let d = new Date(val);
        if (Object.prototype.toString.call(d) === "[object Date]" && !isNaN(d.getTime())) {
            return d.toLocaleDateString() + " " + d.toLocaleTimeString();
        } else {
            return "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = NetworkDiscoveryViewRenderer;
